function SortVariant({ dimensions, col = '#000' }) {
  const baseXml = `
      <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3,13H15V11H3M3,6V8H21V6M3,18H9V16H3V18Z" fill=${`"${col}"`}/>
      </svg>
    `;
  return baseXml;
}

export default SortVariant;
